module.exports = __webpack_public_path__ + "img/racecourse-durbanville-turf-2400.288f70e9.svg";